import ForecastRainfalllists from './lists';

export default ForecastRainfalllists;
